import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div id="main-content" className="flex-1 flex flex-col relative w-full">
        {children}
      </div>
    </div>
  );
};

export default Layout;